import {
  Checkbox,
  Grid,
  PasswordInput,
  Space,
  Text,
  TextInput,
} from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { UserDetailsForm } from '../../../../type/entity.types';
import XCol4 from '../../../x-components/grid-col/x-col-4.component';
import XCol6 from '../../../x-components/grid-col/x-col-6.component';

function PartnerResellerUserDetails(props: Props) {
  const { form } = props;

  return (
    <>
      <Text size='xl' weight={700}>
        User Details
      </Text>
      <Space h='xl' />
      <Grid>
        <XCol4>
          <TextInput
            label={labels.firstName}
            placeholder={placeholders.firstName}
            {...form.getInputProps('firstName')}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.middleName}
            placeholder={placeholders.middleName}
            disabled={form.values.noMiddleName}
            {...form.getInputProps('middleName')}
          />
          <Space my='xs' />
          <Checkbox
            label="I don't have a middle name"
            checked={form.values.noMiddleName}
            onChange={() => {
              const noMiddleName = !form.values.noMiddleName;
              form.setFieldValue('noMiddleName', noMiddleName);
              form.setFieldValue('middleName', noMiddleName ? '.' : '');
            }}
          />
        </XCol4>
        <XCol4>
          <TextInput
            label={labels.lastName}
            placeholder={placeholders.lastName}
            {...form.getInputProps('lastName')}
          />
        </XCol4>
        <XCol6>
          <TextInput
            label={labels.userEmail}
            placeholder={placeholders.userEmail}
            {...form.getInputProps('userEmail')}
          />
        </XCol6>
        <XCol6>
          <TextInput
            label={labels.username}
            placeholder={placeholders.username}
            {...form.getInputProps('username')}
          />
        </XCol6>
        <XCol6>
          <PasswordInput
            label={labels.password}
            placeholder={placeholders.password}
            {...form.getInputProps('password')}
          />
        </XCol6>
        <XCol6>
          <PasswordInput
            label={labels.confirmPassword}
            placeholder={placeholders.confirmPassword}
            {...form.getInputProps('confirmPassword')}
          />
        </XCol6>
      </Grid>
    </>
  );
}

export default PartnerResellerUserDetails;

interface Props {
  form: UseFormReturnType<UserDetailsForm>;
}

const labels = {
  firstName: 'First name',
  middleName: 'Middle name',
  lastName: 'Last name',
  username: 'Username',
  password: 'Password',
  confirmPassword: 'Confirm password',

  userEmail: 'Email',

  //Branch user details
  bldgNameNo: 'Building name and number',
  line1: 'Street address',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  country: 'Country',
  primary: 'Primary contact number',
  fax: 'FAX',
  barangay: 'Barangay',
  mobile: 'Mobile phone number',
};

const placeholders = {
  firstName: 'First name',
  middleName: 'Middle name',
  lastName: 'Last name',
  userEmail: 'Email',

  username: 'Username',
  password: 'Password',
  confirmPassword: 'Confirm password',

  //Branch user details
  bldgNameNo: 'Building name and number',
  line1: 'Street address',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  country: 'Country',
  primary: 'Primary contact number',
  fax: 'FAX',
  barangay: 'Barangay',
  mobile: 'Mobile phone number',
};
